import React from 'react';
import cn from 'classnames';
import Link from 'components/UI/Link';
import { handleLinkClick, pushHeaderEvent } from '../../../utils';

import * as styles from './SubmenuLink.module.scss';

const SubmenuLink = ({
  className,
  title,
  description,
  url,
  mod,
  currentLink,
  deviceType,
  tabIndex,
}) => {
  const isActive = currentLink?.includes(url);

  const handleClick = () => {
    if (mod === 'langSwitcher') {
      pushHeaderEvent('click_on_lang_switch', title, deviceType);
    } else {
      handleLinkClick(url);
    }
  };

  return (
    <Link
      href={url}
      className={cn(styles.wrapLink, className, styles[mod])}
      tabIndex={tabIndex}
      onClick={handleClick}
    >
      <span className={cn(styles.link, isActive && styles.active)}>{title}</span>
      {description && <p className={styles.description}>{description}</p>}
    </Link>
  );
};

export default SubmenuLink;
